




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class RequiredFieldValidator extends Vue {
  @Prop() readonly label!: string;
  @Prop() readonly name!: string;
  @Prop() readonly value!: string;
  @Prop() readonly requiredMessage!: string;

  public isEmpty (): boolean {
    return this.value === undefined || this.value === null || this.value.toString().trim() === '';
  }

  public getMessage (): string {
    if (this.requiredMessage !== undefined && this.requiredMessage !== null && this.requiredMessage.trim() !== '') {
      return this.requiredMessage;
    }

    const message = (this.label !== undefined && this.label !== '') ? this.label : this.name;
    return message + ' is required';
  }

  public getValidationClass (): string {
    return this.isEmpty() ? 'field-validation-error' : 'field-validation-valid';
  }
}
